import { createElementBlock as t, openBlock as c, createElementVNode as l } from "vue";
import o from "./index289.js";
const a = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function r(s, e, f, i, m, p) {
  return c(), t("svg", n, e[0] || (e[0] = [
    l("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      l("path", {
        fill: "#E5F2F9",
        d: "M21.703 35.59c1.111 0 2.158.227 3.073.685.686-4.5 4.61-7.956 9.317-7.956 5.133 0 9.316 4.109 9.448 9.194A6.25 6.25 0 0 1 49 43.741C49 47.197 46.189 50 42.723 50h-21.02c-3.987 0-7.224-3.228-7.224-7.204 0-3.98 3.237-7.206 7.224-7.206Z"
      }),
      l("path", {
        fill: "#FFF3AB",
        d: "M33.374 20.102a8.627 8.627 0 0 0-6.104-2.516c-4.766 0-8.63 3.845-8.63 8.587"
      }),
      l("path", {
        fill: "#000",
        "fill-rule": "nonzero",
        d: "m34.093 27.07-.288.003c-4.583.122-8.52 3.152-9.88 7.377l-.05.162-.107-.029a8.625 8.625 0 0 0-2.065-.243c-4.678 0-8.474 3.786-8.474 8.456 0 4.667 3.798 8.454 8.474 8.454h21.02c4.155 0 7.527-3.362 7.527-7.51l-.004-.253a7.504 7.504 0 0 0-5.339-6.958l-.191-.054-.016-.133c-.697-5.234-5.196-9.273-10.607-9.273Zm0 2.5c4.441 0 8.084 3.554 8.198 7.976a1.25 1.25 0 0 0 1.092 1.207 5 5 0 0 1 4.367 4.988c0 2.764-2.25 5.009-5.027 5.009h-21.02c-3.297 0-5.974-2.67-5.974-5.954 0-3.288 2.676-5.956 5.974-5.956.933 0 1.786.189 2.514.553a1.25 1.25 0 0 0 1.794-.93c.6-3.932 4.037-6.894 8.082-6.894ZM27.27 16.335a9.876 9.876 0 0 1 6.986 2.88 1.25 1.25 0 0 1-1.763 1.772 7.376 7.376 0 0 0-5.223-2.152c-4.077 0-7.38 3.287-7.38 7.337a1.25 1.25 0 0 1-2.5 0c0-5.434 4.425-9.837 9.88-9.837Zm-15.544 8.587a1.25 1.25 0 0 1 .128 2.493l-.128.007H10a1.25 1.25 0 0 1-.128-2.494l.128-.006h1.726Zm4.133-11.87.101.092 1.208 1.223a1.25 1.25 0 0 1-1.678 1.849l-.1-.092L14.18 14.9a1.25 1.25 0 0 1 1.678-1.848Zm24.493.08a1.25 1.25 0 0 1 .102 1.666l-.09.102-1.209 1.224a1.25 1.25 0 0 1-1.87-1.655l.091-.102 1.208-1.223a1.25 1.25 0 0 1 1.768-.011ZM27.262 7.75c.647 0 1.179.492 1.243 1.122l.006.128v1.717a1.25 1.25 0 0 1-2.493.128l-.007-.128V9c0-.69.56-1.25 1.25-1.25Z"
      })
    ], -1)
  ]));
}
const Z = /* @__PURE__ */ o(a, [["render", r]]);
export {
  Z as default
};
